import { NotificationOptions } from './types';
import NNotification from '@/uikit/notification/NNotification.vue';
import { createComponent } from '@/uikit/notification/helpers/element';

const Notification = (options: NotificationOptions) => {
  createComponent(NNotification, options);
};

export default Notification;
